/**
 * Helper function to extract error messages from various error types
 * @param error The error object
 * @returns A string representation of the error message
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
